var React = require('react');
var ReactNative = require('react-native');
var createReactClass = require('create-react-class');
var Animated = require('./Animated');

var {
  AppRegistry,
  View,
  Image,
  ScrollView,
  Easing,
  Text,
  StyleSheet,
} = ReactNative;

var ReUpText = require('../ReUpText');

var PullToRefreshScrollView = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      pullDistancePX: 50,
      minUpdateTime: 1000,
      didStartRefreshing: function(){},
      pullRefreshView: <View style={{height:50,backgroundColor:'blue'}}><ReUpText>Pull to refresh...</ReUpText></View>,
      releaseRefreshView: <View style={{height:50,backgroundColor:'blue'}}><ReUpText>Release to refresh...</ReUpText></View>,
      refreshingView: <View style={{height:50,backgroundColor:'blue'}}><ReUpText>Refreshing...</ReUpText></View>,
    }
  },

  PULL_TO_REFRESH : 0,
  RELEASE_TO_REFRESH : 1,
  REFRESHING : 2,
  getInitialState : function()
  {
    return {
      pullState: this.PULL_TO_REFRESH,
      pullOffset: new Animated.Value(-50),
      pullHeight: new Animated.Value(50),
    }
  },
  componentDidMount : function()
  {
  },

  // _lastOffsetY:0,
  didScroll : function(event)
  {
    // this._lastOffsetY = event.nativeEvent.contentOffset.y;
    if( this.state.pullState == this.PULL_TO_REFRESH )
    {
      if( -event.nativeEvent.contentOffset.y > this.props.pullDistancePX )
      {
        this.setState({pullState: this.RELEASE_TO_REFRESH});
      }
    }
    else if( this.state.pullState == this.RELEASE_TO_REFRESH )
    {
      if( -event.nativeEvent.contentOffset.y < this.props.pullDistancePX )
      {
        this.setState({pullState: this.PULL_TO_REFRESH});
      }
    }
  },

  didRelease : function(event)
  {
    if( this.state.pullState == this.RELEASE_TO_REFRESH )
    {
      this.setIsRefreshing(true);
    }
  },

  isRefreshing : function()
  {
    return this.state.pullState == this.REFRESHING;
  },

  _readyToStopRefreshing: false,
  _shouldStopRefreshing: false,
  setIsRefreshing: function(isRefreshing)
  {
    if( this.isRefreshing() == isRefreshing ) return; // no change, do nothing

    this.setState({
      pullState: this.REFRESHING
    })

    var ptr = this;
    if( isRefreshing )
    {
      this.props.didStartRefreshing(this);
      Animated.timing(
       ptr.state.pullOffset,
       {toValue: 0,
       duration:200,
       easing: Easing.out(Easing.ease)},
      ).start();

      this._readyToStopRefreshing = false;
      this._shouldStopRefreshing = false;
      setTimeout(function()
      {
        ptr._readyToStopRefreshing = true;
        if( ptr._shouldStopRefreshing )
        {
          Animated.timing(          // Uses easing functions
           ptr.state.pullOffset,    // The value to drive
           {toValue: -ptr.props.pullDistancePX,
           duration:100},           // Configuration
          ).start();                // Don't forget start!
          setTimeout(function()
          {
            ptr.setState({pullState:ptr.PULL_TO_REFRESH});
          }, 100)
        }
      }, this.props.minUpdateTime)
    }
    else
    {
      this._shouldStopRefreshing = true;
      if( this._readyToStopRefreshing )
      {
        Animated.timing(          // Uses easing functions
         ptr.state.pullOffset,    // The value to drive
         {toValue: -ptr.props.pullDistancePX,
         duration:100},           // Configuration
        ).start();                // Don't forget start!
        setTimeout(function()
        {
          ptr.setState({pullState:ptr.PULL_TO_REFRESH});
        }, 100)
      }
    }
  },

  scrollTo: function(x, y)
  {
    this._pullToReleaseScroll.scrollTo(x,y);
  },

  currentView: function()
  {
    if( this.state.pullState == this.PULL_TO_REFRESH ) return this.props.pullRefreshView;
    else if( this.state.pullState == this.RELEASE_TO_REFRESH ) return this.props.releaseRefreshView;
    else return this.props.refreshingView;
  },

  getScrollResponder: function()
  {
    return this._pullToReleaseScroll;
  },

  _pullToReleaseScroll : null,
  render: function()
  {
    var { pullDistancePX, onScroll, style, onResponderRelease, pullRefreshView, releaseRefreshView, refreshingView, children, ...other } = this.props;

    return (
      <ScrollView
        key="pullToReleaseScroll" ref={(a)=>this._pullToReleaseScroll = a}
        onScroll={(event) => {this.didScroll(event); if( typeof onScroll !== 'undefined' && onScroll != null ) onScroll(event);}}
        scrollEventThrottle={20}
        removeClippedSubviews={true}
        onResponderRelease={(event) => {this.didRelease(event); if( typeof onResponderRelease !== 'undefined' && onResponderRelease != null ) onResponderRelease(event);}}
        style={[{flex:1},style]}
        contentContainerStyle={{flex:1}}
        {...other}>
        <Animated.View key="pullToReleaseContainer" style={[styles.pullToRefreshViewContainer, {height:this.props.pullDistancePX, marginTop:this.state.pullOffset}]}>
          {this.currentView()}
        </Animated.View>
        {children}
      </ScrollView>
    )
  }
});

var styles = StyleSheet.create({
  pullToRefreshViewContainer:
  {
    flexDirection:'column',
    justifyContent:'flex-end',
    backgroundColor:'red',
  }
});

module.exports = PullToRefreshScrollView;



// WEBPACK FOOTER //
// ./src/wrappers/PullToRefreshScrollView-wrapper.js